<template>
    <div>
        <!-- Header -->
        <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
            <div class="container">
                <div class="header-body text-center mb-4">
                    <div class="row justify-content-center">
                        <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                            <h1 class="text-white">{{ $t('auth.resetPassword') }}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-7">
                    <div class="card card-profile bg-secondary mt-5">
                        <div class="card-body pt-5 px-5">
                            <div class="text-center mb-4">
                                <h3>Set new password</h3>
                            </div>
                            <form role="form">
                                <base-input
                                    prepend-icon="ni ni-lock-circle-open"
                                    type="password"
                                    :placeholder="$t('auth.password')"
                                    name="password"
                                    v-model="user.password"
                                    autofocus
                                    v-validate="userValidations.password"
                                    :error="getError('password')"
                                    @keydown.enter="resetPassword"></base-input>

                                <base-input
                                    prepend-icon="ni ni-lock-circle-open"
                                    type="password"
                                    :placeholder="$t('auth.confirmPassword')"
                                    name="confirm"
                                    v-model="user.confirmPassword"
                                    @keydown.enter="resetPassword"></base-input>

                                <div class="text-center">
                                    <base-button
                                        type="primary"
                                        class="mt-2"
                                        :loading="updatingPassword"
                                        @click="resetPassword">
                                        {{ updatingPassword ? $t('auth.updating') : $t('auth.resetPassword') }}
                                    </base-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import VeeValidateMixin from '@/mixins/vee-validate-mixin'
    import {mapMutations} from 'vuex'

    export default {
        name: 'ForgotPassword',
        mixins: [VeeValidateMixin],
        data() {
            return {
                updatingPassword: false,
                user: {
                    password: null,
                    confirmPassword: null,
                    token: null,
                },
                userValidations: {
                    password: {
                        required: true,
                        min: 5,
                    },
                    confirmPassword: {
                        required: true,
                        confirmed: 'password',
                        // TODO: Implement confirm password validator
                    }
                }
            }
        },
        methods: {
            ...mapMutations({
                login: 'setUser'
            }),
            async resetPassword() {
                const isValid = await this.$validator.validateAll();

                console.log('VALIDATOR: ', isValid);

                if (isValid) {
                    this.updatingPassword = true;
                    this.$axios.post('/api/password/reset', this.user)
                        .then(res => {
                            if (res.data.user) {
                                this.login(res.data.user);
                                this.$router.push('/');
                            } else {
                                this.$router.push('/login');
                            }
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                        .then(() => {
                            this.updatingPassword = false;
                        })
                }
            }
        },
        mounted() {
            if (this.$route.query.token) {
                this.user.token = this.$route.query.token;
            } else {
                this.$router.push('/login');
            }
        },
    };
</script>

<style lang="scss">
    .failed-message {
        font-size: 13px;
        margin-top: -20px;
        margin-bottom: 20px;
    }
</style>
